<template>
  <div class="post-creation-page" :style="{ backgroundImage: backgroundUrl }">
    <div class="form-container-wrapper">
      <div class="logo-festival-wrapper">
        <img :src="logoUrlFestival" alt="Logo Festival" class="logo-festival" />
        <h1 class="page-title text-center mt-3">Đóng góp Bài viết & Cảm xúc</h1>
      </div>

      <!-- START: FORM TẠO BÀI VIẾT (ĐÃ GỘP) -->
      <ValidationObserver
        v-if="!isSubmittedSuccess"
        v-slot="{ invalid, handleSubmit }"
        ref="observer"
      >
        <form @submit.prevent="handleSubmit(handlePost)" ref="formContainer">
          <!-- 1. Tên người đăng (nameAuthor) -->
          <div class="row">
            <div class="col-12 mb-2">
              <ValidationProvider
                :rules="tinTucValidator.rules.nameAuthor"
                name="Tên tác giả"
                v-slot="{ errors }"
              >
                <label class="form-label text-left"
                  >Tên của bạn<span class="required-star">&nbsp;*</span></label
                >
                <input
                  v-model="form.nameAuthor"
                  class="form-control flower-input"
                  placeholder="Ví dụ: Nguyễn Văn A"
                  :class="{ 'is-invalid': errors[0] }"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </ValidationProvider>
            </div>

            <div class="col-md-12 mb-2">
              <div class="mb-2">
                <ValidationProvider
                  :rules="tinTucValidator.rules.describe"
                  name="Nội dung"
                  v-slot="{ errors }"
                >
                  <label class="form-label text-left">Nội dung</label>
                  <span class="required-star"
                    >&nbsp;(Tối đa {{ maxDescribeLength }} ký tự)*</span
                  >
                  <span class="fw-bold ms-2 text-muted character-count">
                    ({{ describeCharacterCount }}/{{ maxDescribeLength }} ký tự)
                  </span>
                  <textarea
                    v-model="form.describe"
                    id="percent"
                    rows="4"
                    type="text"
                    class="form-control flower-input"
                    placeholder="Nhập nội dung bài viết"
                  >
                  </textarea>
                  <small class="text-danger">{{ errors[0] }}</small>
                </ValidationProvider>
              </div>
            </div>

            <!-- 3. Ảnh liên quan (fileImage) -->
            <div class="col-12 mb-0">
              <div class="mb-2">
                <ValidationProvider
                  ref="providerFileImage"
                  name="Ảnh bài viết"
                  :rules="tinTucValidator.rules.fileImage"
                  v-slot="{ errors }"
                >
                  <label class="form-label text-left">
                    Ảnh bài viết<span class="required-star">&nbsp;*</span>
                  </label>
                  <!-- <p
                    class="text-muted small mb-2"
                    style="color: var(--color-blue-sky) !important"
                  >
                    *Tỉ lệ khuyến nghị: 3:2 (Ngang)
                  </p> -->

                  <div class="file-cropper-area">
                    <!-- Input file ẩn -->
                    <input
                      type="file"
                      ref="fileUploader"
                      style="display: none"
                      @change="handleFileChange"
                      accept="image/*"
                    />

                    <!-- Khu vực hiển thị file hiện tại (preview) -->
                    <div
                      v-if="form.fileImage?.fileId"
                      class="image-preview-container"
                    >
                      <!-- Ảnh preview chính -->
                      <img
                        :src="url + form.fileImage.fileId"
                        alt="Ảnh bài viết"
                        class="current-file-image"
                        @click="triggerFileUpload"
                      />

                      <!-- Nút Xóa Ảnh -->
                      <button
                        type="button"
                        class="btn-delete-file d-flex justify-content-center align-items-center"
                        @click.stop="
                          deleteFileOnServer(form.fileImage.fileId, true)
                        "
                      >
                        <i class="fas fa-trash-alt"></i>
                      </button>
                    </div>

                    <!-- Nút chọn ảnh ban đầu -->
                    <button
                      v-else
                      class="btn-select-file"
                      type="button"
                      @click="triggerFileUpload"
                    >
                      <i class="fas fa-plus me-1"></i> Chọn/Tải lên ảnh (Tỉ lệ
                      3:2)
                    </button>

                    <!-- LOADING HÌNH ẢNH SAU KHI CẮT -->
                    <div
                      v-if="isUploadingFile"
                      class="uploading-spinner text-primary mt-2"
                    >
                      <i class="fas fa-spinner fa-spin me-2"></i> Đang tải
                      lên...
                    </div>
                  </div>

                  <small class="text-danger mt-2 d-block">{{
                    errors[0]
                  }}</small>
                </ValidationProvider>
              </div>
            </div>
          </div>

          <!-- FOOTER NÚT HÀNH ĐỘNG -->
          <div
            class="d-flex justify-content-end pt-2 border-top mt-4 flower-footer-actions"
          >
            <!-- Nút Quay lại -->
            <ButtonCore
              type="button"
              text="Quay lại"
              variantClass="btn-close-core"
              iconClass="fas fa-arrow-left"
              :handleClick="() => $router.push('/')"
              :customStyle="{ width: '120px', margin: '0 5px' }"
              :isDisable="isDisableButton || isSubmitting || isUploadingFile"
            />

            <!-- Nút Đăng -->
            <ButtonCore
              type="submit"
              :text="isSubmitting ? 'Đang gửi...' : 'Đăng bài'"
              variantClass="btn-accept-core"
              iconClass="fas fa-paper-plane"
              :handleClick="() => handleSubmit(handlePost)"
              :customStyle="{ width: '130px' }"
              :isDisable="
                invalid || isSubmitting || isDisableButton || isUploadingFile
              "
            />
          </div>
        </form>
      </ValidationObserver>
      <div
        v-else
        class="success-result-wrapper text-center py-4 animate__animated animate__fadeIn"
      >
        <div class="success-icon-box mb-4">
          <i class="fas fa-check-circle icon-succes text-success"></i>
        </div>
        <h4 class="alert-heading fw-bold text-success">
          Bài viết đã được gửi thành công!
        </h4>
        <p class="mb-4 alert-content px-lg-5">
          Cảm ơn bạn đã đóng góp nội dung. Bài viết sẽ được quản trị viên kiểm
          duyệt và đăng tải sớm nhất. Vui lòng chờ đợi trong giây lát!
        </p>

        <div class="d-flex justify-content-center gap-3 mt-4 pt-2">
          <ButtonCore
            text="Trở về Trang chủ"
            variantClass="btn-outline-core"
            :handleClick="() => $router.push('/')"
            :customStyle="{
              height: '40px',
              width: '160px',
              padding: '5px 10px',
            }"
          />
          <ButtonCore
            text="Tiếp tục đăng bài"
            variantClass="btn-success-core"
            :handleClick="handleResetToNew"
            :customStyle="{
              height: '40px',
              width: '160px',
              padding: '5px 10px',
            }"
          />
        </div>
      </div>
      <!-- END: FORM TẠO BÀI VIẾT -->

      <!-- MODAL CROPPER (VẪN CẦN B-MODAL VÀ LOGIC CROPPPER) -->
      <b-modal
        v-model="showCropperModal"
        title="Cắt ảnh theo tỉ lệ (3:2)"
        size="lg"
        centered
        no-close-on-backdrop
        hide-header-close
        hide-footer
        hide-header
        @shown="handleCropperModalShown"
        @hidden="handleCropperModalHidden"
      >
        <div class="d-flex justify-content-end border-bottom pb-2 w-100">
          <ButtonCore
            text="Hủy"
            variantClass="btn-close-core"
            :handleClick="cancelCrop"
            :customStyle="{ width: '70px', margin: '0 5px' }"
            :isDisable="isUploadingFile || isDisableButton"
          />
          <ButtonCore
            :text="isUploadingFile ? 'Đang tải lên...' : 'Lưu'"
            variantClass="btn-accept-core"
            iconClass="fas fa-crop-alt"
            :handleClick="cropAndUpload"
            :customStyle="{ width: '70px' }"
            :isDisable="isUploadingFile || isDisableButton"
          />
        </div>
        <div class="cropper-container">
          <p class="text-muted small mb-2 mt-2">
            Vui lòng điều chỉnh khung để lấy phần ảnh đẹp nhất
          </p>
          <div class="image-cropper-area shadow-inner rounded overflow-hidden">
            <Cropper
              v-if="isCropperVisible"
              ref="cropper"
              :src="rawImageUrl"
              :stencil-props="{ aspectRatio: 3 / 2 }"
              :resize-image="{ adjustStencil: false }"
              :transitions="true"
              class="upload-cropper"
            />
          </div>
        </div>

        <!-- <template #modal-header>
         
        </template> -->
      </b-modal>
    </div>
  </div>
</template>

<script>
// --- IMPORTS CẦN THIẾT CHO FORM VÀ VALIDATION ---
import axios from "axios";
import { tinTucModel } from "@/models/profession/tinTuc/tinTucModel";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { tinTucValidator } from "@/models/profession/tinTuc/tinTucValidator";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";
// Giả định ButtonCore được import từ widgets
import { ButtonCore } from "@/components/widgets";
import { mapActions } from "vuex";
// ------------------------------------------------

export default {
  components: {
    ButtonCore,
    ValidationObserver,
    ValidationProvider,
    Cropper,
  },
  name: "FormCreateFeed",
  data() {
    return {
      isSubmitting: false,
      selectedFile: null,
      isSubmittedSuccess: false,
      isDisableButton: false,
      isUploadingFile: false, // NEW: Trạng thái tải file

      // NEW: State cho Cropping
      showCropperModal: false,
      isCropperVisible: false,
      rawFile: null, // File gốc
      rawImageUrl: null, // URL Base64/Blob của ảnh đã resize (Được dùng làm source cho Cropper)

      tinTucValidator,
      form: {
        nameAuthor: "",
        content: "",
        describe: "", // Thêm trường describe để phù hợp với template
        // Đây là cấu trúc dữ liệu dự kiến sau khi xử lý file upload
        fileImage: {
          fileId: null,
          ext: null,
          path: null,
        },
      },

      url: `${process.env.VUE_APP_API_URL}filesminio/view/`,
      showImageModal: false,
      currentImageSrc: "",

      maxDescribeLength: 500, // Định nghĩa giới hạn

      // Khởi tạo model trống cho lần đầu
      initialForm: {
        nameAuthor: "",
        content: "",
        describe: "",
        fileImage: { fileId: null, ext: null, path: null },
      },
    };
  },
  watch: {
    // Theo dõi file được chọn và reset nếu cần
    selectedFile(newFile) {
      if (!newFile) {
        this.form.fileImage = this.initialForm.fileImage;
      }
    },
    // NEW: Computed property cho URL preview ảnh nhỏ
    previewImageUrl() {
      return this.form.fileImage.fileId
        ? this.url + this.form.fileImage.fileId
        : null;
    },
  },
  computed: {
    logoUrlFestival() {
      return require("@/assets/images/logoFestivalSD.png");
    },
    backgroundUrl() {
      return `url(${require("@/assets/images/login-bg.png")})`;
    },
    // Tính toán số ký tự cho Nội dung
    describeCharacterCount() {
      // Dùng form.describe vì đây là trường được bind trong template
      return this.form.describe ? this.form.describe.length : 0;
    },
  },

  methods: {
    async handlePost() {
      this.isSubmitting = true;
      try {
        if (
          !this.$refs.providerFileImage.errors.length &&
          !this.form.fileImage?.fileId
        ) {
          await this.$store.dispatch("snackBarStore/addNotify", {
            data: {
              code: "WARNING",
              message: "Vui lòng chọn ảnh cho bài viết",
            },
          });
          return;
        }

        this.isLoading = true;

        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });

        const res = await this.$store.dispatch(
          "profession/tinTuc/tinTucStore/create",
          tinTucModel.toJson(this.form)
        );

        if (res.code === 0) {
          // Hiển thị thông báo thành công trong modal
          this.isSubmittedSuccess = true;
          this.isDisableButton = true;

          // await this.$store.dispatch("snackBarStore/addNotify", {
          //   data: {
          //     code: res.code,
          //     message: "Bài viết đã được gửi thành công!",
          //   },
          // });
          // Gọi hàm đóng modal, hàm này sẽ trì hoãn việc đóng
          // this.closeModal();
        } else {
          this.$store.dispatch("snackBarStore/addNotify", {
            data: {
              code: res.code,
              message: res.message,
            },
          });
        }

        loader.hide();
        this.submitted = false;
      } catch (err) {
        console.error("Submission error:", err);
        this.$store.dispatch("snackBarStore/addNotify", {
          data: {
            code: -1,
            message: "Có lỗi xảy ra trong quá trình đăng bài.",
          },
        });
      } finally {
        this.isSubmitting = false;
      }
    },

    resizeImage(file) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (readerEvent) => {
          const img = new Image();
          img.onload = () => {
            const MAX_WIDTH = 1500; // Giới hạn chiều rộng tối đa 1500px
            const MAX_HEIGHT = 1000; // Giới hạn chiều cao tối đa 1000px
            let width = img.width;
            let height = img.height;
            let ratio = width / height;

            if (width > MAX_WIDTH || height > MAX_HEIGHT) {
              if (width > height) {
                height = MAX_WIDTH / ratio;
                width = MAX_WIDTH;
              } else {
                width = MAX_HEIGHT * ratio;
                height = MAX_HEIGHT;
              }
            }

            const canvas = document.createElement("canvas");
            canvas.width = width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");

            // Vẽ ảnh đã resize lên canvas
            ctx.drawImage(img, 0, 0, width, height);

            // Chuyển Canvas thành Data URL (Base64) với chất lượng nén 0.8 (JPEG)
            const resizedDataUrl = canvas.toDataURL("image/jpeg", 0.8);

            resolve(resizedDataUrl);
          };
          img.src = readerEvent.target.result;
        };
        reader.readAsDataURL(file);
      });
    },
    // BƯỚC 1: Kích hoạt input file ẩn
    // resizeImage(file) {
    //   return new Promise((resolve) => {
    //     const reader = new FileReader();
    //     reader.onload = (readerEvent) => {
    //       const img = new Image();
    //       img.onload = () => {
    //         const MAX_WIDTH = 1500; // Giới hạn chiều rộng tối đa 1500px
    //         const MAX_HEIGHT = 1000; // Giới hạn chiều cao tối đa 1000px
    //         let width = img.width;
    //         let height = img.height;
    //         let ratio = width / height;

    //         if (width > MAX_WIDTH || height > MAX_HEIGHT) {
    //           if (width > height) {
    //             height = MAX_WIDTH / ratio;
    //             width = MAX_WIDTH;
    //           } else {
    //             width = MAX_HEIGHT * ratio;
    //             height = MAX_HEIGHT;
    //           }
    //         }

    //         const canvas = document.createElement("canvas");
    //         canvas.width = width;
    //         canvas.height = height;
    //         const ctx = canvas.getContext("2d");

    //         // Vẽ ảnh đã resize lên canvas
    //         ctx.drawImage(img, 0, 0, width, height);

    //         // Chuyển Canvas thành Data URL (Base64) với chất lượng nén 0.8 (JPEG)
    //         const resizedDataUrl = canvas.toDataURL("image/jpeg", 0.8);

    //         resolve(resizedDataUrl);
    //       };
    //       img.src = readerEvent.target.result;
    //     };
    //     reader.readAsDataURL(file);
    //   });
    // },
    // BƯỚC 1: Kích hoạt input file ẩn
    triggerFileUpload() {
      this.$refs.fileUploader.click();
    },

    async handleFileChange(event) {
      const file = event.target?.files?.[0];
      if (!file || !file.type.startsWith("image/")) return;

      // GIỚI HẠN FILE ẢNH DƯỚI 40MB
      const maxSize = 40 * 1024 * 1024;
      if (file.size > maxSize) {
        this.$store.dispatch("snackBarStore/addNotify", {
          data: {
            code: -1,
            message:
              "Kích thước ảnh không được vượt quá 40MB. Vui lòng chọn ảnh nhỏ hơn.",
          },
        });
        event.target.value = "";
        return;
      }

      this.rawFile = file;

      // Đọc file trực tiếp để đưa vào Cropper mà không Resize
      const reader = new FileReader();
      reader.onload = (e) => {
        this.rawImageUrl = e.target.result;
        this.showCropperModal = true;
      };
      reader.readAsDataURL(file);

      event.target.value = "";
    },
    // BƯỚC 3: Hàm xử lý khi Cropper Modal MỞ XONG
    handleCropperModalShown() {
      // QUAN TRỌNG: Dùng $nextTick để mount Cropper SAU KHI DOM đã ổn định
      this.$nextTick(() => {
        this.isCropperVisible = true;
      });
    },
    // BƯỚC 4: Hàm xử lý khi Cropper Modal ĐÓNG
    handleCropperModalHidden() {
      this.isCropperVisible = false;
      this.rawFile = null;
      this.rawImageUrl = null;
    },

    // BƯỚC 5: Hàm hủy crop (gọi từ nút Hủy)
    cancelCrop() {
      this.showCropperModal = false; // Đóng modal, logic reset file chạy ở handleCropperModalHidden
    },

    // BƯỚC 6: HÀM XỬ LÝ CROP VÀ UPLOAD
    cropAndUpload() {
      if (!this.$refs.cropper) return;

      const { canvas } = this.$refs.cropper.getResult();
      if (!canvas) return;

      // Đặt trạng thái loading ngay lập tức
      this.isUploadingFile = true;

      // Xóa ảnh cũ trước khi upload ảnh mới
      if (this.form.fileImage.fileId) {
        this.deleteFileOnServer(this.form.fileImage.fileId, false);
      }

      // Chuyển canvas thành Blob để gửi đi như một file
      canvas.toBlob(
        async (blob) => {
          this.showCropperModal = false; // Đóng cropper

          const formData = new FormData();
          const originalFileName = this.rawFile.name;
          const fileExt = originalFileName.split(".").pop() || "jpg";
          const fileNameWithExt =
            originalFileName.replace(/\.[^/.]+$/, "") + `_cropped.${fileExt}`;

          formData.append("files", blob, fileNameWithExt);

          try {
            const response = await axios.post(
              `${process.env.VUE_APP_API_URL}filesminio/Upload`,
              formData
            );

            if (response.data.code === 0 && response.data.data?.fileId) {
              this.form.fileImage = {
                fileId: response.data.data.fileId,
                fileName: response.data.data.fileName,
                ext: fileExt,
                path: response.data.data.path,
              };
              this.$refs.providerFileImage.validate();
              // this.$store.dispatch("snackBarStore/addNotify", {
              //   data: { message: "Ảnh đã được cắt và lưu!", code: 0 },
              // });
            } else {
              this.$store.dispatch("snackBarStore/addNotify", {
                data: {
                  message: response.data.message || "Tải ảnh thất bại!",
                  code: -1,
                },
              });
            }
          } catch (error) {
            this.$store.dispatch("snackBarStore/addNotify", {
              data: { message: "Đã xảy ra lỗi khi tải ảnh.", code: -1 },
            });
          } finally {
            this.isUploadingFile = false; // Reset loading state
          }
        },
        "image/jpeg",
        0.9
      );
    },

    // BƯỚC 7: XÓA ẢNH (Click nút Xóa trên preview)
    async handleDeleteFile() {
      if (!confirm("Bạn có chắc chắn muốn xóa ảnh này không?")) return;

      const fileId = this.form.fileImage.fileId;
      if (!fileId) return;

      const success = await this.deleteFileOnServer(fileId, true);

      if (success) {
        this.form.fileImage = { fileId: null, ext: null, path: null };
        this.$refs.providerFileImage.validate(); // Kích hoạt validation lại
      }
    },

    // Hàm xóa file trên server (Được gọi khi đóng modal hoặc xóa ảnh)
    async deleteFileOnServer(fileId, isNotify = true) {
      try {
        await axios
          .post(`${process.env.VUE_APP_API_URL}filesminio/delete/${fileId}`)
          .then((res) => {
            if (res.data.code === 0) {
              this.form.fileImage = { fileId: null, ext: null, path: null };
              this.$refs.providerFileImage.validate(); // Kích hoạt validation lại
              // if (isNotify) {
              //   this.$store.dispatch("snackBarStore/addNotify", {
              //     data: { message: "Xóa file thành công!", code: 0 },
              //   });
              // }
            }
          });
        return true;
      } catch (e) {
        console.error("Lỗi xóa file:", e);
        // if (isNotify) {
        //   this.$store.dispatch("snackBarStore/addNotify", {
        //     data: { message: "Lỗi khi xoá file trên server.", code: -1 },
        //   });
        // }
        return false;
      }
    },

    // HÀM RESET VÀ QUAY LẠI FORM NHẬP LIỆU
    handleResetToNew() {
      this.isSubmittedSuccess = false;
      this.resetForm();
    },

    closeModal() {
      // Logic xóa file cũ khi đóng nếu chưa submitted
      if (this.form.fileImage?.fileId && !this.isSubmittedSuccess) {
        this.deleteFileOnServer(this.form.fileImage.fileId, false);
      }

      if (this.isSubmittedSuccess) {
        // setTimeout(() => {
        //   this.$bvModal.hide("create-news-modal");
        this.resetForm();
        // }, 3000);
      } else {
        this.$bvModal.hide("create-news-modal");
        this.resetForm();
      }
    },
    resetForm() {
      this.form = Object.assign({}, this.initialForm);
      this.selectedFile = null;
      this.isSubmitting = false;
      this.isSubmittedSuccess = false;
      this.isDisableButton = false;
      this.isUploadingFile = false;
      if (this.$refs.observer) {
        this.$refs.observer.reset();
      }
    },
  },
  created() {
    this.initialForm = Object.assign({}, this.form);
  },
};
</script>

<style scoped>
/* ======================================== */
/* STYLE TRANG CHÍNH (PAGE WRAPPER) */
/* ======================================== */
.post-creation-page {
  min-height: 100vh;
  width: 100%;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 15px;
  background-blend-mode: overlay;
  background-color: rgba(255, 255, 255, 0.4);
}

.form-container-wrapper {
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 15px;
  padding: 30px;
  max-width: 800px;
  width: 100%;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  z-index: 10;
}

.logo-festival-wrapper {
  text-align: center;
  margin-bottom: 10px;
}

.logo-festival {
  width: 200px;
  height: auto;
}

.page-title {
  font-size: 1.3rem;
  font-weight: 700;
  color: var(--color-primary, #007bff);
}

/* ======================================== */
/* STYLE FORM VÀ CÁC THÀNH PHẦN (TỪ FORMCREATEFEED) */
/* ======================================== */

.file-cropper-area {
  min-height: 40px;
}
.image-preview-container {
  margin-top: 10px;
  position: relative;
  display: block;
  max-width: 300px;
  border-radius: 8px;
  overflow: hidden;
}
.current-file-image {
  max-width: 100%;
  height: auto;
  max-height: 200px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s;
  cursor: pointer;
}
.btn-select-file {
  padding: 8px 15px;
  background-color: var(--color-primary, #007bff);
  color: white;
  border: none;
  border-radius: 6px;
  font-weight: 500;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.btn-delete-file {
  position: absolute;
  top: 5px;
  right: 5px;
  background-color: var(--color-danger, #dc3545);
  color: white;
  border: none;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  opacity: 0.9;
  transition: opacity 0.2s;
  cursor: pointer;
}

/* INPUTS */
.flower-input {
  border-radius: 8px;
  border: 1px solid var(--color-gray, #ccc);
  padding: 10px 15px;
  height: auto;
}
.form-label {
  font-weight: 600;
  color: var(--color-dark, #333);
  margin-bottom: 0.2rem;
}
.required-star {
  color: var(--color-danger, #dc3545);
  font-weight: 500;
}
.flower-footer-actions {
  border-top: 1px dashed var(--color-gray, #ccc);
}
.flower-alert {
  background-color: #e6f7e6;
  border-color: #b7e0b7;
  color: var(--color-secondary);
  border-radius: 8px;
}
.uploading-spinner {
  font-size: 0.9rem;
  font-weight: 600;
}
.cropper-area {
  max-height: 400px;
  width: 100%;
}
/* ======================================== */
/* SUCCESS STATE STYLES */
/* ======================================== */
.success-result-wrapper {
  animation-duration: 0.8s;
}

.alert-heading {
  font-size: 1.3rem;
}
.alert-content {
  font-size: 1.1rem;
}

.success-icon-box i {
  filter: drop-shadow(0 4px 10px rgba(40, 167, 69, 0.3));
}
.icon-succes {
  font-size: 4.5rem;
}

/* RESPONSIVE */
@media (min-width: 376px) and (max-width: 580px) {
  .form-container-wrapper {
    padding: 20px;
  }
  .logo-festival {
    width: 160px;
    height: auto;
  }

  .icon-succes {
    font-size: 4.2rem;
  }

  .page-title {
    font-size: 1.1rem;
  }
  .flower-input {
    border-radius: 8px;
    border: 1px solid var(--color-gray, #ccc);
    padding: 8px 10px;
  }
  .image-preview-container {
    margin-top: 5px;
    position: relative;
    display: block;
    max-width: 185px;
    border-radius: 8px;
    overflow: hidden;
  }

  .alert-heading {
    font-size: 1.2rem;
  }
  .alert-content {
    font-size: 0.9rem;
  }
}

@media (max-width: 375px) {
  .form-container-wrapper {
    padding: 20px;
  }
  .logo-festival {
    width: 150px;
    height: auto;
  }
  .logo-festival-wrapper {
    text-align: center;
    margin-bottom: 5px;
  }

  .page-title {
    font-size: 1.1rem;
  }
  .flower-input {
    border-radius: 8px;
    border: 1px solid var(--color-gray, #ccc);
    padding: 6px 7px;
  }
  .image-preview-container {
    margin-top: 3px;
    position: relative;
    display: block;
    max-width: 160px;
    border-radius: 8px;
    overflow: hidden;
  }

  .icon-succes {
    font-size: 4rem;
  }

  .alert-heading {
    font-size: 1.1rem;
  }
  .alert-content {
    font-size: 0.9rem;
  }
}
</style>
